import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CreateModal } from "../../../../shared/components/Modal";
import { useGetBotijao } from "../../hooks/useGetBotijoes";
import usePutBotijao from "../../hooks/usPutBotijao";
import { Botijao, BotijaoModulo } from "../../types/Botijao";
import { FormBotijao } from "../Form";

interface VisualizarBotijaoProps {
  idBotijao: number
  onCancel: () => void
  deleteModal: () => void
  visible: boolean
  resetForm: () => void
  setIdBotijao: any
}

export function VisualizarBotijao({ idBotijao, onCancel, deleteModal, visible, resetForm, setIdBotijao} : VisualizarBotijaoProps) {
  const { data: botijaoData } = useGetBotijao(idBotijao)
  
  const [botijao, setBotijao] = useState<BotijaoModulo>()
  const [disabled, setDisabled] = useState<boolean>(true)
  const {mutate : salvarEdicaoProduto, isLoading: LoadingButton} = usePutBotijao(reset);

  const {register, handleSubmit} = useForm<Botijao>({
    defaultValues: {
      Nome: botijao?.Nome,
    }
  });

  function reset() {
    resetForm()
    handleHabilitaInput()
    setIdBotijao(undefined)
  }

  useEffect(() => {
    botijaoData && setBotijao(botijaoData)
  }, [botijaoData])

  function handleHabilitaInput () {
    setDisabled(!disabled)
  }

  async function onSubmit(data : Botijao) {
    await salvarEdicaoProduto({
      botijaoAtual: botijao? botijao : botijaoData,
      data,
      id : idBotijao
    })
  }

  return (
    <>
      <CreateModal
        title="Visualizar de Botijão"
        isModalOpen={visible}
        onCancel={onCancel}
        disabled={disabled}
        onSubmit={handleSubmit(onSubmit)}
        setDisabled={handleHabilitaInput}
        deleteOpenModal={() => {
          onCancel();
          deleteModal();
        }}
        closable
        hasId
        isLoading={LoadingButton}
      >
        <div className="flex justify-center">
          <FormBotijao
            botijao={botijao}
            visualizar
            inputDisabled={disabled}
            register={register}
          />
        </div>
      </CreateModal>
    </>
  );
}
